module.exports = __webpack_public_path__ + "img/mark.eaec5ca4.svg";